
import { prioritizeItem } from "~/utils/displayRules";

export default {
  props: {
    treeId: String,
    active: String,
  },

  data() {
    return {
      categories: [],
      isLoading: false,
      isEmpty: false,
      canScrollLeft: false,
      canScrollRight: false,
    };
  },

  computed: {
    sortedCategories() {
      return prioritizeItem(this.categories, (c) => c.treeId === "  675", 1);
    },
  },

  methods: {
    async getCategories() {
      this.isLoading = true;

      try {
        this.categories = await this.$axios.$get("categories", {
          params: {
            parentId: this.treeId,
          },
        });
      } catch (err) {
        this.__logError(err);
      }

      this.isEmpty = !this.categories.length;
      this.isLoading = false;

      this.$nextTick(() => {
        this.checkScroll();
      });
    },

    handleScroll() {
      this.checkScroll();
    },

    checkScroll() {
      // Reached from mounted(), from a resize listener, and from a $nextTick after
      // the categories request — that last one can land after the component is gone
      // (navigating before it resolves), when $refs is already empty. A plain guard,
      // not a try/catch: catching turned a missing ref into a logged "error" that
      // read like a real fault.
      const el = this.$refs.tabs;
      if (!el) return;

      this.canScrollLeft = el.scrollLeft > 0;
      this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth;
    },
  },

  created() {
    this.getCategories();
  },

  mounted() {
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  },
};
